import { NgClass } from '@angular/common';
import { booleanAttribute, Component, input } from '@angular/core';

@Component({
    selector: 'app-panel',
    template: `
        <div class="{{ class() }}" [ngClass]="[withPanel() ? 'panel' : '', panelClass()]">
            <ng-content/>
        </div>
    `,
    imports: [NgClass],
})
export class PanelComponent {
    class = input<string>('');
    panelClass = input<string>('');
    withPanel = input<boolean, unknown>(true, {transform: booleanAttribute});
}
